import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { createPollTemplateRequested } from 'features/polls/actions';

export function* createPollTemplateSaga(action: ReturnType<typeof createPollTemplateRequested>) {
  yield call(SignalingSocket.send, { event: 'createPollTemplate', data: action.payload });
}
